import {
  Auth,
  linkWithCredential,
  OAuthCredential,
  signInWithCustomToken,
  UserCredential
} from "firebase/auth";

import getMISSignInToken from "../../../services/authenticationService/getMISSignInToken";

export default async function attemptFirstMISLogin({
  auth,
  credential,
  email
}: {
  auth: Auth;
  credential: OAuthCredential;
  email: string;
}): Promise<UserCredential> {
  if (!credential.idToken) {
    throw new Error("MIS recovery requires an idToken, but the credential has none");
  }

  const misToken = await getMISSignInToken(credential.idToken);

  if (!misToken) {
    throw new Error("getMISSignInToken returned no custom token");
  }

  const userCredential = await signInWithCustomToken(
    auth,
    misToken.customToken
  );

  await linkWithCredential(userCredential.user, credential);

  return userCredential;
}
